import { twMerge } from "tailwind-merge";
import { Type } from "@themes/pollinator/ui/Type";
import { RequirementCheck } from "@themes/pollinator/ui/RequirementCheck";
import type { SchedulingMode } from "@core/features/actions";

export type Props = {
  className?: string;
  mode: SchedulingMode;
  // Freeform mode
  validHoursCount?: number;
  minRequiredHours?: number;
  // Options modes (select-options and repeating)
  selectedCount?: number;
  requiredSelections?: number;
};

export function SchedulingRequirements({
  className,
  mode,
  validHoursCount = 0,
  minRequiredHours = 10,
  selectedCount = 0,
  requiredSelections = 1,
}: Props) {
  const betterMatchHours = minRequiredHours + 4;

  return (
    <div className={twMerge("flex flex-col gap-4 px-4", className)}>
      <Type variant="h4">Requirements</Type>

      {mode === "freeform" && (
        <>
          <RequirementCheck
            isMet={validHoursCount >= minRequiredHours}
            message={`Select at least ${minRequiredHours} hours when you'll be available.`}
          />
          <RequirementCheck
            isMet={validHoursCount >= betterMatchHours}
            message={`Get a better match: Add another 4 hours of availability (${betterMatchHours} hours total).`}
          />
          <RequirementCheck
            isMet={validHoursCount > betterMatchHours}
            message={`Get the best match possible: Select ${betterMatchHours}+ hours of availability.`}
          />
        </>
      )}

      {mode === "select-options" && (
        <RequirementCheck
          isMet={selectedCount >= requiredSelections}
          message={`Select ${requiredSelections} option${requiredSelections !== 1 ? "s" : ""} from the available time blocks.`}
        />
      )}

      {mode === "repeating" && (
        <RequirementCheck
          isMet={selectedCount >= requiredSelections}
          message={`Select ${requiredSelections} time slot${requiredSelections !== 1 ? "s" : ""}.`}
        />
      )}
    </div>
  );
}

export default SchedulingRequirements;
